// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__rxD7r","modal":"Modal_modal__EqaZW","slide-down":"Modal_slide-down__T8wwY"};